@if (useDesignSystem()) {
  <button joii-button [variant]="buttonStyleType()" (click)="onButtonClick()">{{ attachment().button_text }}</button>
} @else {
  @switch (buttonStyleType()) {
    @case ('secondary') {
      <button class="joii-btn-primary bg-white border-2 border-primary text-primary" (click)="onButtonClick()">
        {{ attachment().button_text }}
      </button>
    }
    @default {
      <button class="joii-btn-primary border-2 border-primary" (click)="onButtonClick()">
        {{ attachment().button_text }}
      </button>
    }
  }
}
